import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-02/lesson-15/task-01";

const task: Slide = {
  title: "Match these recording devices/techniques to whether they are meant for mono, stereo, or binaural recording",
  description: "Connect with lines.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
